import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Salamander silhouette uses the ★1 tier art. The active
// rendering for the Salamander unit goes through TIERED_GLYPHS (see
// tieredGlyphs.ts) which routes ★2/★3 to the richer tier images
// extracted from assets/salamander_coil_3tier.jpg.
export const Salamander = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/salamander-1.png" size={size} alt="salamander" />
)
